import { debounce } from 'lodash';

import brief from './brief';
import assets from './assets';
import fileRequests from './fileRequests';
import production from './production';
import delivery from './delivery';
import documents from './documents';
import { createFolder, updateFolder, archiveFolder, listOptions, listIndustries, listCommunicationObjectives, listCampaignObjectives, listProductionTypes, listRegions, listBrandsFromAccess, listCreativeTechnic, listCreator, listCreators, publishToAccess } from '@/api/workflow'

import {
  listBrands,
  listUsers,
  listProjects,
  updateProjectField,
  updateProject,
  deleteProject,
  exportProjects,
  listBrandsManual,
  shareProjectResource,
  fetchProjectResourceByToken
} from '@/api/workflow';

const PROJECT_STATUSES = [
  //{
  //  id: 'started',
  //  name: 'Started',
  //  selectable: true
  //},
  //{
  //  id: 'on-hold',
  //  name: 'On hold',
  //  selectable: true
  //},
  // {
  //   id: 'production',
  //   name: 'Production',
  //   selectable: true
  // },
  {
    id: 'delivered',
    name: 'Delivered',
    selectable: true
  },
  //{
  //  id: 'not-started',
  //  name: 'Not started',
 //  selectable: true
  //},
  //{
  //  id: 'closed',
  //  name: 'Closed',
  //  selectable: false
  //},
  {
    id: 'archived',
    name: 'Archived',
    selectable: true
  },
];

const PROJECT_OBJECTIVES = [
  {
    id: 'raise-awareness',
    name: 'Raise awareness'
  },
  {
    id: 'encourage-trial',
    name: 'Encourage trial'
  },
  {
    id: 'increase-app-download-install',
    name: 'Increase app download / install'
  },
  {
    id: 'drive-immediate-purchase',
    name: 'Drive immediate purchase'
  },
  {
    id: 'drive-engagement',
    name: 'Drive engagement (share, comments, likes, reactions)'
  },
  {
    id: 'increase-viewthrough',
    name: 'Increase viewthrough'
  },
  {
    id: 'drive-increase-to-site-clicks',
    name: 'Drive increase to site / clicks'
  },
  {
    id: 'other',
    name: 'Other'
  }
];

const PROJECT_PLATFORMS = [
  {
    id: 'meta',
    name: 'Meta'
  },
  {
    id: 'instagram',
    name: 'Instagram'
  },
  {
    id: 'pinterest',
    name: 'Pinterest'
  },
  {
    id: 'snapchat',
    name: 'Snapchat'
  },
  {
    id: 'tiktok',
    name: 'TikTok'
  },
  {
    id: 'youtube',
    name: 'YouTube'
  }
];

export default {
  namespaced: true,
  modules: {
    brief,
    assets,
    fileRequests,
    production,
    delivery,
    documents
  },
  state: () => ({
    statuses: {
      items: PROJECT_STATUSES
    },
    objectives: {
      items: PROJECT_OBJECTIVES
    },
    platforms: {
      items: PROJECT_PLATFORMS
    },
    accessBrands: {
      loading: false,
      error: null,
      items: []
    },
    industryTypes: {
      loading: false,
      error: null,
      items: []
    },
    productionTypes: {
      loading: false,
      error: null,
      items: []
    },
    campaignObjectives: {
      loading: false,
      error: null,
      items: []
    },
    creativeTechnic: {
      loading: false,
      error: null,
      items: []
    },
    communicationObjectives: {
      loading: false,
      error: null,
      items: []
    },
    creators: {
      loading: false,
      error: null,
      items: []
    },
    regions: {
      loading: false,
      error: null,
      items: []
    },
    brands: {
      loading: false,
      error: null,
      items: []
    },
    brandsManual: {
      loading: false,
      error: null,
      items: []
    },
    users: {
      loading: false,
      error: null,
      items: []
    },
    myProjects: {
      loading: false,
      error: null,
      items: [],
      users: {
        items: []
      },
      brands: {
        items: []
      },
      options: {
        platforms: [],
        programs: [],
        partners: [],
        projectTypes: [],
        productionTypes: [],
        initiatives: [],
        groups: [],
      },
      filters: {
        query: null,
        statuses: ['delivered'],
        brands: [],
        users: [],
        dueDate: null
      }
    },
    currentProjectId: null,
    currentProject: {
      loading: false,
      error: null,
      value: null
    },
    sharedResource: {
      error: null,
      loading: false,
      project: null,
      resource: null,
      description: null,
      token: null
    },
    projectsById: {}
  }),
  mutations: {
    fetchBrandsPending(state) {
      state.brands.loading = true;
      state.brands.error = null;
      state.brands.items = [];
    },
    fetchBrandsSuccess(state, brands) {
      state.brands.loading = false;
      state.brands.error = null;
      state.brands.items = brands;
    },
    fetchBrandsFailure(state, error) {
      state.brands.loading = false;
      state.brands.error = error;
    },
    fetchBrandsManualPending(state) {
      state.brandsManual.loading = true;
      state.brandsManual.error = null;
      state.brandsManual.items = [];
    },
    fetchBrandsManualSuccess(state, brands) {
      state.brandsManual.loading = false;
      state.brandsManual.error = null;
      state.brandsManual.items = brands;
    },
    fetchBrandsManualFailure(state, error) {
      state.brandsManual.loading = false;
      state.brandsManual.error = error;
    },
    fetchUsersPending(state) {
      state.users.loading = true;
      state.users.error = null;
      state.users.items = [];
    },
    fetchUsersSuccess(state, projects) {
      state.users.loading = false;
      state.users.error = null;
      state.users.items = projects;
    },
    fetchUsersFailure(state, error) {
      state.users.loading = false;
      state.users.error = error;
    },
    fetchProjectOptionsPending(state) {
      state.myProjects.loading = true;
      state.myProjects.error = null;
    },
    fetchProjectOptionsSuccess(state, { projectTypes, partners, programs, platforms, productionTypes, initiatives, groups }) {
      state.myProjects.loading = false;
      state.myProjects.error = null;
      state.myProjects.options.projectTypes = projectTypes;
      state.myProjects.options.productionTypes = productionTypes;
      state.myProjects.options.partners = partners;
      state.myProjects.options.programs = programs;
      state.myProjects.options.platforms = platforms;
      state.myProjects.options.initiatives = initiatives;
      state.myProjects.options.groups = groups;
    },
    fetchProjectOptionsFailure(state, error) {
      state.myProjects.loading = false;
      state.myProjects.error = error;
    },
    fetchMyProjectsPending(state) {
      state.myProjects.loading = true;
      state.myProjects.error = null;
      state.myProjects.items = [];
      state.myProjects.folders = [];
    },
    fetchMyProjectsSuccess(state, { projects, brands, users, folders }) {
      state.myProjects.loading = false;
      state.myProjects.error = null;
      state.myProjects.items = projects;
      state.myProjects.folders = folders;
      state.myProjects.brands.items = brands;
      state.myProjects.users.items = users;
      projects.forEach(folder => {
        folder.projects.forEach(project => (state.projectsById[project.id] = project))
      });
    },
    fetchMyProjectsFailure(state, error) {
      state.myProjects.loading = false;
      state.myProjects.error = error;
    },
    fetchCurrentProjectPending(state, projectId) {
      state.currentProjectId = projectId;
      state.currentProject.loading = true;
      state.currentProject.error = null;
      state.currentProject.value = null;
    },
    fetchCurrentProjectSuccess(state, project) {
      state.currentProject.loading = false;
      state.currentProject.error = null;
      state.currentProject.value = project;
      state.projectsById[project.id] = project;
    },
    fetchCurrentProjectResourcePending(state, token) {
      state.sharedResource.loading = true;
      state.sharedResource.error = null;
      state.sharedResource.project = null;
      state.sharedResource.resource = null;
      state.sharedResource.token = token;
    },
    fetchCurrentProjectResourceSuccess(state, { project, resource, token, description }) {
      state.sharedResource.loading = false;
      state.sharedResource.error = null;
      state.sharedResource.project = project;
      state.sharedResource.description = description;
      state.sharedResource.resource = resource;
      state.sharedResource.token = token;
      state.currentProject.value = project;
      state.projectsById[project.id] = project;
    },
    fetchCurrentProjectResourceFailure(state, error) {
      state.sharedResource.loading = false;
      state.sharedResource.error = error;
      state.sharedResource.project = null;
      state.sharedResource.resource = null;
    },
    fetchCurrentProjectFailure(state, error) {
      state.currentProject.loading = false;
      state.currentProject.error = error;
    },
    setMyProjectsFilter(state, { field, value }) {
      state.myProjects.filters[field] = value;
    },
    updateFolder(state, folder) {
      state.myProjects.items = state.myProjects.items.map(item => {
        return item.id === folder.id ? folder : item;
      })
    },
    updateSharedResourceData(state, data) {
      state.sharedResource.resource.data = data;
    },
    addFolder(state, folder) {
      state.myProjects.items = [].concat(state.myProjects.items, folder);
    },
    removeProject(state, { id }) {
      state.myProjects.items = state.myProjects.items.filter(project => project.id != id);
    },
    changeProjectFolder(state, { project, destinationId }) {
      if (project.folder_id == destinationId) return;
      state.myProjects.items = state.myProjects.items.map(folder => {
        if (folder.id === destinationId) {
          folder.projects = [].concat(folder.projects, project);
        }

        if (folder.id === project.folder_id) {
          folder.projects = folder.projects.filter(p => p.id !== project.id);
        }

        return folder;
      });

      const destinationFolder = state.myProjects.items.find(f => f.id === destinationId);

      const current = state.projectsById[project.id];

      if (current) {
        current.folder = destinationFolder;
        current.folder_id = destinationId;
        if (state.currentProjectId == project.id) {
          state.currentProject.value.folder = destinationFolder;
          state.currentProject.value.folder_id = destinationId;
        }
      }
    },
    setProjectField(state, { projectId, field, value }) {
      const project = state.projectsById[projectId];
      if (project) {
        project[field] = value;
        if (state.currentProjectId == projectId) {
          state.currentProject.value[field] = value;
        }
      }
    },
    fetchAccessBrandsPending(state) {
      state.accessBrands.loading = true;
    },
    fetchAccessBrandsSuccess(state, regions) {
      state.accessBrands.items = [...regions];
      state.accessBrands.loading = false;
      state.accessBrands.error = null;
    },
    fetchAccessBrandsFailure(state, error) {
      state.accessBrands.error = error;
      state.accessBrands.loading = false;
    },
    fetchCreatorsPending(state) {
      state.creators.loading = true;
    },
    fetchCreatorsSuccess(state, regions) {
      state.creators.items = [...regions];
      state.creators.loading = false;
      state.creators.error = null;
    },
    fetchCreatorsFailure(state, error) {
      state.creators.error = error;
      state.creators.loading = false;
    },
    fetchIndustryTypesPending(state) {
      state.industryTypes.loading = true;
    },
    fetchIndustryTypesSuccess(state, regions) {
      state.industryTypes.items = [...regions];
      state.industryTypes.loading = false;
      state.industryTypes.error = null;
    },
    fetchIndustryTypesFailure(state, error) {
      state.industryTypes.error = error;
      state.industryTypes.loading = false;
    },
    fetchCampaignObjectivesPending(state) {
      state.campaignObjectives.loading = true;
    },
    fetchCampaignObjectivesSuccess(state, regions) {
      state.campaignObjectives.items = [...regions];
      state.campaignObjectives.loading = false;
      state.campaignObjectives.error = null;
    },
    fetchCampaignObjectivesFailure(state, error) {
      state.campaignObjectives.error = error;
      state.campaignObjectives.loading = false;
    },
    fetchCommunicationObjectivesPending(state) {
      state.communicationObjectives.loading = true;
    },
    fetchCommunicationObjectivesSuccess(state, regions) {
      state.communicationObjectives.items = [...regions];
      state.communicationObjectives.loading = false;
      state.communicationObjectives.error = null;
    },
    fetchCommunicationObjectivesFailure(state, error) {
      state.communicationObjectives.error = error;
      state.communicationObjectives.loading = false;
    },
    fetchCreativeTechnicPending(state) {
      state.creativeTechnic.loading = true;
    },
    fetchCreativeTechnicSuccess(state, regions) {
      state.creativeTechnic.items = [...regions];
      state.creativeTechnic.loading = false;
      state.creativeTechnic.error = null;
    },
    fetchCreativeTechnicFailure(state, error) {
      state.creativeTechnic.error = error;
      state.creativeTechnic.loading = false;
    },
    fetchProductionTypesPending(state) {
      state.productionTypes.loading = true;
    },
    fetchProductionTypesSuccess(state, productionTypes) {
      state.productionTypes.items = [...productionTypes];
      state.productionTypes.loading = false;
      state.productionTypes.error = null;
    },
    fetchProductionTypesFailure(state, error) {
      state.productionTypes.error = error;
      state.productionTypes.loading = false;
    },
    fetchRegionsPending(state) {
      state.regions.loading = true;
    },
    fetchRegionsSuccess(state, regions) {
      state.regions.items = [...regions];
      state.regions.loading = false;
      state.regions.error = null;
    },
    fetchRegionsFailure(state, error) {
      state.regions.error = error;
      state.regions.loading = false;
    },
  },
  actions: {
    async createFolder({ commit }, { name, partner, project_type, brands, groups, industry, country }) {
      const data = await createFolder({ name, partner, project_type, brands, groups, industry, country });

      commit('addFolder', data);
      return data;
    },
    updateSharedResourceData({ commit }, data) {
      commit('updateSharedResourceData', data);
    },
    async archiveFolder({ commit }, { id }) {
      const data = await archiveFolder(id);

      commit('removeProject', { id });
      return true;
    },
    async updateFolder({ commit, state }, { name, id }) {
      const data = await updateFolder({ name, id });

      commit('updateFolder', data);
      return true;
    },
    async publishAssetsToAccess({ commit }, assets) {
      try {
        return await publishToAccess(assets);
      } catch (err) {
        console.error('Server error when listing industy types from access api', err);
        throw err;
      }
    },
    async fetchRegions({ commit, state }, force = false) {
      if (state.regions.items.length > 0 && !force) {
        return;
      }
      commit('fetchRegionsPending');
      try {
        const result = await listRegions();
        commit('fetchRegionsSuccess', result);
      } catch (err) {
        console.error('Server error when listing industy types from access api', err);
        commit('fetchRegionsFailure', 'Error when listing industy types from access api');
      }
    },
    async fetchProductionTypes({ commit, state }, force = false) {
      if (state.productionTypes.items.length > 0 && !force) {
        return;
      }
      commit('fetchProductionTypesPending');
      try {
        const result = await listProductionTypes();
        commit('fetchProductionTypesSuccess', result);
      } catch (err) {
        console.error('Server error when listing industy types from access api', err);
        commit('fetchProductionTypesFailure', 'Error when listing industy types from access api');
      }
    },
    async fetchCreativeTechnic({ commit, state }, force = false) {
      if (state.creativeTechnic.items.length > 0 && !force) {
        return;
      }
      commit('fetchCreativeTechnicPending');
      try {
        const result = await listCreativeTechnic();
        commit('fetchCreativeTechnicSuccess', result);
      } catch (err) {
        console.error('Server error when listing industy types from access api', err);
        commit('fetchCreativeTechnicFailure', 'Error when listing industy types from access api');
      }
    },
    async fetchCommunicationObjectives({ commit, state }, force = false) {
     /* if (state.communicationObjectives.items.length > 0 && !force) {
        return;
      }*/
      commit('fetchCommunicationObjectivesPending');
      try {
        const result = await listCommunicationObjectives();
        commit('fetchCommunicationObjectivesSuccess', result);
      } catch (err) {
        console.error('Server error when listing industy types from access api', err);
        commit('fetchCommunicationObjectivesFailure', 'Error when listing industy types from access api');
      }
    },
    async fetchCampaignObjectives({ commit, state }, force = false) {
      if (state.campaignObjectives.items.length > 0 && !force) {
        return;
      }
      commit('fetchCampaignObjectivesPending');
      try {
        const result = await listCampaignObjectives();
        commit('fetchCampaignObjectivesSuccess', result);
      } catch (err) {
        console.error('Server error when listing campaign objectives from access api', err);
        commit('fetchCampaignObjectivesFailure', 'Error when listing campaign objectives from access api');
      }
    },
    async fetchIndustryTypes({ commit, state }, force = false) {
      if (state.industryTypes.items.length > 0 && !force) {
        return;
      }
      commit('fetchIndustryTypesPending');
      try {
        const result = await listIndustries();
        result.sort(function(a,b){
          return a.name.localeCompare(b.name);
        })
        commit('fetchIndustryTypesSuccess', result);
      } catch (err) {
        console.error('Server error when listing industy types from access api', err);
        commit('fetchIndustryTypesFailure', 'Error when listing industy types from access api');
      }
    },
    async fetchCreators({ commit, state }, force = false) {
      if (state.creators.items.length > 0 && !force) {
        return;
      }
      commit('fetchCreatorsPending');
      try {
        const result = await listCreators();
        commit('fetchCreatorsSuccess', result);
      } catch (err) {
        console.error('Server error when listing creators from access api', err);
        commit('fetchCreatorsFailure', 'Error when listing creators from access api');
      }
    },
    async fetchExternalBrands({ commit, state }, force = false) {
      if (state.accessBrands.items.length > 0 && !force) {
        return;
      }
      commit('fetchAccessBrandsPending');
      try {
        const result = await listBrandsFromAccess();
        commit('fetchAccessBrandsSuccess', result);
      } catch (err) {
        console.error('Server error when listing brands from access api', err);
        commit('fetchAccessBrandsFailure', 'Error when listing brands from access api');
      }
    },
    async fetchBrands({ commit, state }, force = false) {
      if (state.brands.items.length > 0 && !force) {
        return;
      }
      commit('fetchBrandsPending');
      try {
        const result = await listBrandsFromAccess();
        commit('fetchBrandsSuccess', result);
      } catch (err) {
        console.error('Server error when listing brands', err);
        commit('fetchBrandsFailure', 'Error when listing brands');
      }
    },
    async fetchBrandsManual({ commit, state }) {
      if (state.brandsManual.items.length > 0) {
        return;
      }
      commit('fetchBrandsManualPending');
      try {
        const result = await listBrandsManual();
        commit('fetchBrandsManualSuccess', result);
      } catch (err) {
        console.error('Server error when listing brands', err);
        commit('fetchBrandsManualFailure', 'Error when listing brands');
      }
    },
    async fetchUsers({ commit, state }) {
      if (state.users.items.length > 0) {
        return;
      }
      commit('fetchUsersPending');
      try {
        const result = await listUsers();
        commit('fetchUsersSuccess', result);
      } catch (err) {
        console.error('Server error when listing users', err);
        commit('fetchUsersFailure', 'Error when listing users');
      }
    },
    async fetchMyProjects({ commit, state }) {
      commit('fetchMyProjectsPending');
      try {
        const payload = {
          filters: state.myProjects.filters
        };
        const result = await listProjects(payload);
        commit('fetchMyProjectsSuccess', result);
      } catch (err) {
        console.error('Server error when listing my projects', err);
        commit('fetchMyProjectsFailure', 'Error when listing my projects');
      }
    },
    async fetchProjectOptions({ commit, state }) {
      commit('fetchProjectOptionsPending');
      try {
        const result = await listOptions();
        commit('fetchProjectOptionsSuccess', result);
      } catch (err) {
        console.error('Server error when listing project options', err);
        commit('fetchProjectOptionsFailure', 'Error when listing project options');
      }
    },
    fetchMyProjectsDebounced: debounce(({ dispatch }) => {
      dispatch('fetchMyProjects');
    }, 500),
    async updateMyProjectsQuery({ commit, dispatch }, { query }) {
      commit('setMyProjectsFilter', { field: 'query', value: query });
      dispatch('fetchMyProjectsDebounced');
    },
    async updateMyProjectsFilter({ commit, dispatch }, { field, value }) {
      commit('setMyProjectsFilter', { field, value });
      dispatch('fetchMyProjects');
    },
    async fetchProjectResource({ commit }, { token }) {
      commit('fetchCurrentProjectResourcePending', token);
      try {
        const payload = {
          token
        };
        const { sharing, resource, project, description } = await fetchProjectResourceByToken(payload);
        if (!project) {
          commit('fetchCurrentProjectResourceFailure', 'Shared resource not found');
        } else {
          commit('fetchCurrentProjectResourceSuccess', { sharing, resource, project, token, description });
        }
      } catch (err) {
        console.error('Server error when fetching share resource', err);
        commit('fetchCurrentProjectResourceFailure', 'Error when listing current project');
      }
    },
    async fetchProject({ commit, state }, { projectId }) {
      if (state.currentProjectId === projectId) {
        return;
      }
      commit('fetchCurrentProjectPending', projectId);
      try {
        const payload = {
          projectId
        };
        const { projects } = await listProjects(payload);
        const folder = projects.find(folder => folder.projects.length > 0);
        if (folder == null) {
          commit('fetchCurrentProjectFailure', 'Project not found');
        } else {
          commit('fetchCurrentProjectSuccess', folder.projects[0]);
        }
      } catch (err) {
        console.error('Server error when listing current project', err);
        commit('fetchCurrentProjectFailure', 'Error when listing current project');
      }
    },
    async shareProjectResource({ commit }, { projectId, resource, extras, description }) {
      try {
        const payload = {
          projectId,
          resource,
          extras,
          description
        };
        const data = await shareProjectResource(payload);
        commit('setProjectField', {
          projectId: projectId,
          field: 'sharings',
          value: data.sharings
        });

        return data;
      } catch (err) {
        console.error(`Server error when share project ${projectId} ${resource} page`, err);
      }
    },
    async updateProjectStatus({ commit, state }, { project, value }) {
      const previousValue = state.projectsById[project.id].status;
      commit('setProjectField', {
        projectId: project.id,
        field: 'status',
        value
      });
      try {
        const payload = {
          project,
          field: 'status',
          value
        };
        await updateProjectField(payload);
      } catch (err) {
        console.error(`Server error when updating status of project ${project.id}`, err);
        commit('setProjectField', {
          projectId: project.id,
          field: 'status',
          value: previousValue
        });
      }
    },
    async updateProjectBroadcastingRights({ commit, state }, { project, value }) {
      const previousValue = state.projectsById[project.id].broadcastingRights;
      commit('setProjectField', {
        projectId: project.id,
        field: 'broadcastingRights',
        value
      });
      try {
        const payload = {
          project,
          field: 'broadcastingRights',
          value
        };
        await updateProjectField(payload);
      } catch (err) {
        console.error(`Server error when updating broadcasting rights of project ${project.id}`, err);
        commit('setProjectField', {
          projectId: project.id,
          field: 'broadcastingRights',
          value: previousValue
        });
      }
    },
    async updateProjectFolder({ commit, state }, { project, value }) {
      try {
        const payload = {
          project,
          field: 'folder',
          value: value
        };
        await updateProjectField(payload);
        commit('changeProjectFolder', {
          project,
          destinationId: value
        })
      } catch (err) {
        console.error(`Server error when updating folder of project ${project.id}`, err);
      }
    },
    async updateProjectUsers({ commit, state }, { project, value }) {
      const previousValue = state.projectsById[project.id].users;
      commit('setProjectField', {
        projectId: project.id,
        field: 'users',
        value
      });
      try {
        const payload = {
          project,
          field: 'userIds',
          value: value.map(u => u.id)
        };
        await updateProjectField(payload);
      } catch (err) {
        console.error(`Server error when updating status of project ${project.id}`, err);
        commit('setProjectField', {
          projectId: project.id,
          field: 'users',
          value: previousValue
        });
      }
    },
    exportProjects({ commit }) {
      try {
        return exportProjects();
      } catch (err) {
        console.error(`Server error when exporting projects`, err);
        commit('fetchCurrentProjectFailure', 'Error when exporting projects');
      }
    },
    async deleteProject({ commit }, { project }) {
      try {
        const payload = {
          project: project
        };
        await deleteProject(payload);
        commit('removeProject', project);
      } catch (err) {
        console.error(`Server error when deleting project`, err);
        commit('fetchCurrentProjectFailure', 'Error when deleting project');
      }
    },
    async updateCurrentProjectGeneralInfo({ commit, state }, { name, parentProjectId, brandIds, dueDate, status, projectType, folder, partner, program, platform, newBrands, productionType, country, group, industry, groups, newGroups, initiatives}) {
      try {
        const payload = {
          project: state.currentProject.value,
          name,
          parentProjectId,
          brandIds,
          newBrands,
          newGroups,
          dueDate,
          status,
          folder,
          projectType,
          partner,
          program,
          platform,
          productionType,
          country,
          group,
          industry,
          groups,
          initiatives
        };
        const result = await updateProject(payload);
        commit('fetchCurrentProjectSuccess', result);
      } catch (err) {
        // console.error(`Server error when updating current project general info`, err);
        commit('fetchCurrentProjectFailure', 'Error when updating current project');
        throw err
      }
    }
  }
};
